import { AlertResponse, GetAlertData } from "./api";

export const ApiDataHandler = async (
  config: object
): Promise<AlertResponse | null> => {
  const ret = await GetAlertData(config);

  return ret;
};
